<script lang="ts">
  import Bouton from '../../ui/Bouton.svelte';
  import EnteteAutonome from '../../ui/EnteteAutonome.svelte';
  import { fabriqueFilAriane, type PropriétésFilAriane } from '../../ui/filAriane';
  import FilAriane from '../../ui/FilAriane.svelte';
  import HerosRiche from '../../ui/HerosRiche.svelte';
  import EvaluationExposition from './EvaluationExposition.svelte';
  import { menacesPertinentes, type MenaceEvaluee, type ReponsesExposition } from './expositionCyberattaques';
  import FormulaireExposition from './FormulaireExposition.svelte';
  import RadarExpositionAnime from './RadarExpositionAnime.svelte';

  let { mode, urlBase = '' }: { mode?: 'autonome'; urlBase?: string } = $props();

  const propriétésFilAriane: PropriétésFilAriane = {
    branche: { nom: 'Faire le test !', lien: '/faire-le-test/' },
    feuille: 'Mon organisation est-elle exposée aux cyberattaques ?',
  };

  let étape: 'formulaire' | 'résultats' = $state('formulaire');
  let menaces: MenaceEvaluee[] = $state([]);
  let enPause = $state(false);
  const libelléPause = $derived(enPause ? 'Lancer les animations' : 'Mettre les animations en pause');

  const évalue = (reponses: ReponsesExposition) => {
    menaces = menacesPertinentes(reponses);
    étape = 'résultats';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const basculePause = () => {
    enPause = !enPause;
  };
</script>

{#if étape === 'formulaire'}
  {#if mode === 'autonome'}
    <dsfr-container>
      <EnteteAutonome {urlBase} />
    </dsfr-container>
  {:else}
    <HerosRiche
      {propriétésFilAriane}
      variante="cafe-creme"
      class="avec-image-fond"
      badges={[{ label: '⏱️ 2 minutes', accent: 'green-bourgeon' }]}
      tailleBadges="md"
      description="Rançongiciel, fraude au virement, espionnage, déstabilisation, cyberharcèlement : chaque attaque poursuit un but différent. En 2 minutes, situez celles qui pèsent le plus sur votre organisation."
    >
      {#snippet titreHtml()}
        Quels types de cyber&shy;attaques peuvent cibler mon organisation ?
      {/snippet}
      {#snippet illustration()}
        <div class="illustration-du-bandeau">
          <div class="radar">
            <RadarExpositionAnime {enPause} />
          </div>
          <div class="controle-animation">
            <Bouton
              type="secondaire"
              icone={enPause ? 'play-circle-line' : 'pause-circle-line'}
              iconeSeule
              libelle={libelléPause}
              titre={libelléPause}
              surClic={basculePause}
            />
          </div>
        </div>
      {/snippet}
    </HerosRiche>
  {/if}

  <FormulaireExposition onévaluer={évalue} {urlBase} />
{:else}
  {#if mode !== 'autonome'}
    <dsfr-container>
      <FilAriane segments={fabriqueFilAriane(propriétésFilAriane)} />
    </dsfr-container>
  {/if}
  <EvaluationExposition {menaces} {mode} {urlBase} />
{/if}

<style lang="scss">
  .illustration-du-bandeau {
    width: 100%;
  }

  .radar {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .controle-animation {
    text-align: right;

    @media (prefers-reduced-motion: reduce) {
      display: none;
    }
  }
</style>
